import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { sendPendingOrderDeliveryEmail } from 'services';
import { showError, showSuccess } from 'utils';

const PendingOrderDeliveryEmail = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleSendDeliveryEmailClick = async () => {
    setLoading(true);
    try {
      await sendPendingOrderDeliveryEmail();
      showSuccess('Order deliver Email request will be processed now');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ActionButton
      text={'Send Pending Order Delivery Email'}
      active={true}
      isLoading={loading}
      onClick={handleSendDeliveryEmailClick}
    />
  );
};

export default PendingOrderDeliveryEmail;
